import * as React from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

type BoxProps = React.ComponentProps<typeof Box>

interface Props {
  toggle: (value: boolean) => BoxProps['onClick']
  open: boolean
}

const FilterSelect = ({ toggle, open }: Props) => {
  return (
    <Box
      onClick={toggle(true)}
      flexDirection="row"
      alignItems="center"
      width="s120"
      justifyContent="spaceBetween"
      background="grey000White"
      border={{
        all: {
          width: 's2',
          style: 'solid',
          color: 'grey400',
        },
      }}
      borderRadius={{
        all: 'abs008',
      }}
      paddingX="s12"
      paddingY="s8"
      height="full"
    >
      <Icon.Medium icon="filter" />
      <Text size="300">{i18n.t('surveys.index.table.filter')}</Text>
      <Icon.Small icon={open ? 'caret-up' : 'caret-down'} />
    </Box>
  )
}

export default FilterSelect
